import 'slideout/index.css';
import '../css/theme.css';
import '../css/splide.min.css';
import { Slideout } from './modules/Slideout';
import { LazyLoader } from './modules/LazyLoader';
import { Theme } from './classes/Theme';
import { Pagination } from './modules/Pagination';
import { Accordion } from './modules/Accordion';
import { Quantity } from './modules/Quantity';
import { ProductGallery } from './modules/ProductGallery';
import { Carousel } from './modules/Carousel';
document.addEventListener('DOMContentLoaded', function () {
    var theme = new Theme({
        lazyLoader: new LazyLoader(),
        slideout: new Slideout(),
        pagination: new Pagination(),
        accordion: new Accordion(),
        quantity: new Quantity(),
        productGallery: new ProductGallery(),
        carousel: new Carousel()
    });
    theme.load();
});
